
import ImageWithWebp from 'Src/js/components/ImageWithWebp.vue';
import Price from 'Src/js/components/price/Price.vue';
import { defineComponent } from "vue";
import { IWorkOrderInstallableProductResource } from '../../types/session';
import { PropType } from 'vue';

export default defineComponent({
	name: "WorkOrderVehicle",
	components: {
		ImageWithWebp,
		Price
	},
	props: {
		product: { type: Object as PropType<IWorkOrderInstallableProductResource> }
	},
});
